import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from 'prop-types';

class BodyPanelWizardSteps extends Component {

  static propTypes = {
    availableSteps: PropTypes.array,
    featureWizardStep: PropTypes.number,
    setFeatureWizardStep: PropTypes.func,
    exitFeatureWizard: PropTypes.func,
    enableFeatureWizard: PropTypes.func,
    toggleWizardFilterSelection: PropTypes.func,
    getFilterDisplayName: PropTypes.func.isRequired,
    showFeatureWizard: PropTypes.bool,
    activeSubPart: PropTypes.object,
  };

  setFeatureWizardStep = (nextStep) => {
    switch (nextStep) {
      case "back":
        nextStep = this.props.featureWizardStep === 0 ? 0 : this.props.featureWizardStep - 1;
        break;
      case "next":
        if (this.props.featureWizardStep === (this.props.availableSteps.length - 1)) {
          this.props.exitFeatureWizard(this.state.availableSteps, this.props.featureWizardStep);
        } else {
          nextStep = this.props.featureWizardStep + 1;
        }
        break;
      default:
        break;
    }
    const currentStep = this.props.availableSteps[nextStep - 1];
    const fabricatorSettings = this.props.fabricatorSettings;
    const allStepsCompleted = this.props.availableSteps.filter(step => !step.hidden).every(step => step.selectedValueId);
    if ((nextStep > this.props.featureWizardStep) && currentStep && !allStepsCompleted
      && (!currentStep.selectedValueId || (fabricatorSettings.leadCapture && currentStep.selectedItemIsLocked && !this.props.isPhoneNumberValidated))) {
      return
    }
    if (this.props.showFeatureWizard) {
      this.props.setFeatureWizardStep(nextStep);
      if (nextStep === 0) {
        this.props.toggleWizardFilterSelection(false);
      }
    } else {
      this.props.enableFeatureWizard(nextStep);
    }
  };

  render() {
    const fabricatorSettings = this.props.fabricatorSettings;
    const availableSteps = this.props.availableSteps.filter(step => !step.hidden);
    const allStepsCompleted = availableSteps.every(step => step.selectedValueId);

    const activeSubPart = this.props.activeSubPart;
    const itemIsSelected = (!fabricatorSettings.leadCapture
      || (activeSubPart.activeFeature && !activeSubPart.activeFeature.partName.includes("WizardPlaceholder")
        && activeSubPart.firstClick[this.props.activeQuoteIndex] && activeSubPart.placeholderChanged));

    return (
      <div className="panel-wizard">
        <ul className="panel-wizard-list">
          <li className={"panel-wizard-list__button panel-wizard-list__button--all"
          + (!this.props.showFeatureWizard ? " panel-wizard-list__button--active" : "")}
              onClick={() => this.props.exitFeatureWizard(availableSteps, this.props.featureWizardStep)}>
            {/*<span className="panel-wizard-list__button-icon"/>*/}
            <span className="panel-wizard-list__button-text">
              <FormattedMessage id="filterSelection.allProducts"/>
            </span>
          </li>
          {availableSteps.map((wizardButton, index) => {
            const prevStep = availableSteps[index - 1];
            const disabled = this.props.showFeatureWizard
              ? (index && !allStepsCompleted && (!prevStep.selectedValueId
                || (fabricatorSettings.leadCapture && prevStep.selectedItemIsLocked && !this.props.isPhoneNumberValidated)))
              : (index && !itemIsSelected && !availableSteps[index - 1].selectedValueId);
            return (
              <li className={"panel-wizard-list__button panel-wizard-list__button--" + wizardButton.filterName.replace(/ /g,"").toLowerCase()
              + (index === this.props.featureWizardStep ? " panel-wizard-list__button--active" : "")
              + (disabled ? " panel-wizard-list__button--disabled" : "")}
                  key={"wizardButton"+index} onClick={() => this.setFeatureWizardStep(index)}>
                <span className="panel-wizard-list__button-icon"/>
                <span className="panel-wizard-list__button-text">
                  {this.props.getFilterDisplayName(wizardButton.filterName, this.props.intl)}
                </span>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  filterGroups: store.filterState.filterGroups,
  fabricatorSettings: store.fabricatorState.settings,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = () => ({});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(BodyPanelWizardSteps)
);
